import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Badge } from "@/components/ui/badge";
import { Building2, Send, Gamepad2, Users, ShieldAlert } from "lucide-react";

const KPI = ({ icon: Icon, label, value, testid }) => (
  <Card className="p-5" data-testid={testid}>
    <div className="flex items-start justify-between">
      <div>
        <p className="text-xs uppercase tracking-wider text-muted-foreground">{label}</p>
        <p className="font-heading text-3xl font-semibold mt-1 tabular-nums">{value}</p>
      </div>
      <div className="h-10 w-10 rounded-xl bg-primary/20 text-primary grid place-items-center">
        <Icon className="h-5 w-5" />
      </div>
    </div>
  </Card>
);

export default function AdminDashboardPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.adminOverview()
      .then((r) => setData(r.data))
      .finally(() => setLoading(false));
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-semibold">Admin Dashboard</h1>
        <p className="text-muted-foreground text-sm">Manage vendors, activate subscriptions, and monitor activity.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {loading || !data ? (
          [0, 1, 2, 3].map((i) => <Card key={i} className="p-5"><Skeleton className="h-16 w-full" /></Card>)
        ) : (
          <>
            <KPI icon={Building2} label="Total Vendors" value={data.vendors.total} testid="kpi-total-vendors" />
            <KPI icon={ShieldAlert} label="Pending" value={data.vendors.pending} testid="kpi-pending-vendors" />
            <KPI icon={Gamepad2} label="Active Campaigns" value={data.campaigns.active} testid="kpi-active-campaigns" />
            <KPI icon={Send} label="Messages Sent" value={data.total_messages} testid="kpi-messages-total" />
          </>
        )}
      </div>

      {!loading && data && (
        <Card className="p-5">
          <h2 className="font-heading text-lg font-semibold mb-3">Vendor status breakdown</h2>
          <div className="flex flex-wrap gap-3">
            <Badge variant="outline" className="text-amber-400 border-amber-400/40" data-testid="badge-pending-count">
              {data.vendors.pending} pending
            </Badge>
            <Badge variant="outline" className="text-emerald-400 border-emerald-400/40" data-testid="badge-active-count">
              {data.vendors.active} active
            </Badge>
            <Badge variant="outline" className="text-red-400 border-red-400/40" data-testid="badge-suspended-count">
              {data.vendors.suspended} suspended
            </Badge>
          </div>
          <p className="text-sm text-muted-foreground mt-3">Total spins captured across platform: <span className="text-foreground font-semibold tabular-nums">{data.total_leads}</span></p>
        </Card>
      )}
    </div>
  );
}
